import {AppActionType, AppActionTypes} from "./types";

export const expandSideMenu = (): AppActionType => ({type: AppActionTypes.EXPAND_SIDE_MENU});
export const collapseSideMenu = (): AppActionType => ({type: AppActionTypes.COLLAPSE_SIDE_MENU});
